<template>
  <div class="openness-box">
    <div class="banner">
      <div class="content-1200 H100 flex-column flex-centent">
        <div class="title fontWeight-800 fontSize48">开放能力</div>
        <div class="desc fontSize16 color-level4">
          为了让开发者可以使用更多的系统能力，并降低接入成本，我们制定了联盟开放能力的<br>统一标准。
        </div>
      </div>
    </div>
    <div class="openness-detail">
      <reveal-animation>
        <section class="content-box">
          <div class="content">
            <div class="content-img-box left">
              <img src="@/assets/img/openness/k.png" width="100%" alt="">
            </div>
            <div class="content-text-box left">
              <div class="content-title">
                K歌耳返
              </div>
              <div class="content-txt">
                录音K歌时实现耳机返听，同时提供多种混响和均衡效果。
              </div>
              <a class="content-btn" href="http://39.106.70.232:41180/gsaidemo/audiodemo" target="_blank">
                立即查看
              </a>
            </div>
          </div>
        </section>
      </reveal-animation>
      <reveal-animation>
        <section class="content-box">
          <div class="content">
            <div class="content-img-box right">
              <img src="@/assets/img/openness/roi.png" width="100%" alt="">
            </div>
            <div class="content-text-box left">
              <div class="content-title">
                ROI编码
              </div>
              <div class="content-txt ">
                支持调用系统编码器的ROI功能，提升直播、视频通话场景中局部区域的清晰度。
              </div>
              <a class="content-btn" href="http://39.106.70.232:41180/gsaidemo/roiencodedemo" target="_blank">
                立即查看
              </a>
            </div>
          </div>
        </section>
      </reveal-animation>
      <reveal-animation>
        <section class="content-box">
          <div class="content">
            <div class="content-img-box left">
              <img src="@/assets/img/openness/4D.png" width="100%" alt="">
            </div>
            <div class="content-text-box left">
              <div class="content-title">
                4D震感
              </div>
              <div class="content-txt ">
                支持多种线性马达波形震感，丰富应用体验。
              </div>
              <a class="content-btn" href="http://gitlab.itgsa.com:41180/gsaidemo/hapticdemo" target="_blank">
                立即查看
              </a>
            </div>
          </div>
        </section>
      </reveal-animation>
    </div>
    <div class="foot-box">
      <reveal-animation :options="{duration:1000,delay:0}">
        <div>
          <h3 class="foot-title">告诉我们您希望开放的其他能力</h3>
          <a class="foot-btn" href="mailto:service@itgsa.com">
            联盟邮箱
            <br>
            service@itgsa.com
          </a>
        </div>
      </reveal-animation>
    </div>
  </div>
</template>

<script>
import RevealAnimation from "@/components/common/RevealAnimation";

export default {
  components: {RevealAnimation},
  data() {
    return {
      num: 0,
      data: [
        {
          img: require("@/assets/img/openness/k.png"),
          title: "K歌耳返",
          text: '录音K歌时实现耳机返听，同时提供多种混响和均衡效果。',
          url: "http://39.106.70.232:41180/gsaidemo/audiodemo"
        },
        {
          img: require("@/assets/img/openness/roi.png"),
          title: "ROI编码",
          text: '支持调用系统编码器的ROI功能，提升直播、视频通话场景中局部区域的清晰度。',
          url: "http://39.106.70.232:41180/gsaidemo/roiencodedemo"
        },
        {
          img: require("@/assets/img/openness/4D.png"),
          title: "4D震感",
          text: '支持多种线性马达波形震感，丰富应用体验。',
          url: "http://gitlab.itgsa.com:41180/gsaidemo/hapticdemo"
        },
      ]
    }
  },
  methods: {
    changes(key) {
      this.num = key;
    },
  }
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.openness-box {
  .banner {
    width: 100%;
    height: 600px;
    background-image: url("~@/assets/img/openness/openness-banner.jpg");
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;

    .title {
      margin-bottom: 12px;
      background: linear-gradient(359.9999999898547deg, #F5CE99 0%, #FFF2C6 52%, #F5CE99 100%);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      -webkit-text-fill-color: transparent;
    }

    .desc {
      width: 644px;
      margin-bottom: 32px;
      line-height: 27px;
    }

    .more-btn {
      background: linear-gradient(90deg, #F5CE99 0%, #FFF2C6 52%, #F5CE99 100%);
      border: 1px solid transparent;
      margin: initial;
    }
  }

  .content-box {
    display: flex;
    align-items: center;
    height: 420px;

    .content {
      width: 1200px;
      margin: auto;
      overflow: hidden;

      .content-img-box {
        width: 460px;
        margin-right: 80px;
      }

      .content-text-box {
        padding-top: 73px;

        .content-title {
          font-weight: 800;
          font-size: 36px;
          color: #333333;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .content-txt {
          margin-top: 12px;
          margin-bottom: 32px;
          font-weight: 500;
          font-size: 14px;
          color: #666666;
          line-height: 24px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .content-btn {
          display: block;
          width: 120px;
          height: 40px;
          border-radius: 52px;
          border: 1px solid #999999;
          text-align: center;
          line-height: 40px;
          font-size: 14px;
          color: #666666;

          &:hover {
            color: $color-level1;
            background: linear-gradient(90deg, #F5CE99 0%, #FFF2C6 52%, #F5CE99 100%);
            border: 1px solid transparent;
          }
        }
      }
    }
  }

  .openness-detail .load-hidden:nth-child(2n) {
    background-color: #262626;

    .content-text-box {
      .content-title {
        color: #fff;
      }

      .content-txt {
        color: #B2B2B2;
      }

      .content-btn {
        color: #fff;
        border-color: #B2B2B2;
      }
    }
  }

  .foot-box {
    display: block;
    margin: auto;
    width: 100%;
    height: 200px;
    padding-top: 50px;
    background-image: url(~@/assets/img/openness/openness-foot.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    .foot-title {
      width: 366px;
      margin: auto;
      font-size: 24px;
      line-height: 28px;
      font-weight: 800;
      color: #f2e9c1;
      background: linear-gradient(to right, #F5CE99 0%, #f2e9c1 50%, #F5CE99 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }

    .foot-btn {
      display: block;
      margin: auto;
      margin-top: 20px;
      width: 220px;
      height: 48px;
      padding-top: 4px;
      text-align: center;
      background: linear-gradient(90deg, #F5CE99 10%, #FFF2C6 50%, #F5CE99 90%);
      border-radius: 60px;
      font-weight: bold;
      font-size: 14px;
      color: #333333;
    }
  }
}


</style>
